import { t } from "i18n-js";
import React from "react";
import { ListItemAssetLarge } from "../ListItemAssetLarge";

import version, { MANUFACTURE_DATE } from "../../version";

const Bulletpoint = (props: any) => {
  return (
    <div>
      <li className="TITLE_5" style={styles.textStyle}>
        {props.text}
      </li>
    </div>
  );
};

export const LabellingScreen = () => {
  const getAsset = (name: string) => {
    return "/assets/" + name + ".png";
  };
  return (
    <div style={{ textAlign: "center" }}>
      <div
        style={{
          height: "100%",
          padding: "20px",
          maxWidth: "600px",
          display: "inline-block",
          textAlign: "left",
        }}
        className="REGULAR"
      >
        <h2 className="TITLE_2">{t("LABELLING_APP_TITLE")}</h2>
        <p className="SMALL_TEXT2">{t("LABELLING_APP_VERSION", { version })}</p>
        <ListItemAssetLarge
          style={styles.listItems}
          text={t("LABELLING_CE")}
          icon={getAsset("ce")}
          testID={"labellingScreen_ce"}
        />
        <ListItemAssetLarge
          style={styles.listItems}
          text={t("LABELLING_CE")}
          icon={getAsset("medical_device")}
          testID={"labellingScreen_ce"}
        />
        <ListItemAssetLarge
          style={styles.listItems}
          text={"(01)4260705080042(11)220500(8012)1.2.0"}

          text2={"GS1-128"}
          icon={getAsset("udidi")}
          testID={"labellingScreen_manufacturerOutline"}
        />
        <ListItemAssetLarge
          style={styles.listItems}
          text={MANUFACTURE_DATE ?? t("LABELLING_MANUFACTURER_1")}
          icon={getAsset("manufacturer_outline")}
          testID={"labellingScreen_manufacturerOutline"}
        />
        <ListItemAssetLarge
          style={styles.listItems}
          text={t("LABELLING_MANUFACTURER_2")}
          icon={getAsset("manufacturer")}
          testID={"labellingScreen_manufacturer"}
        />
        <h3 className="TITLE_3" style={styles.sectionTitle}>
          {t("LABELLING_INTENDED_PURPOSE_TITLE")}
        </h3>
        <p className="REG_TEXT">{t("LABELLING_INTENDED_PURPOSE")}</p>
        <h3 className="TITLE_3" style={styles.sectionTitle}>
          {t("LABELLING_INDICATION_TITLE")}
        </h3>
        <p className="REG_TEXT">{t("LABELLING_INDICATION")}</p>
        <h3 className="TITLE_3" style={styles.sectionTitle}>
          {t("LABELLING_INTENDED_PATIENT_TITLE")}
        </h3>
        <p className="REG_TEXT">{t("LABELLING_INTENDED_PATIENT")}</p>
        <h3 className="TITLE_3" style={styles.headlineBulletPoints}>
          {t("LABELLING_SAFETY_TITLE")}
        </h3>
        <Bulletpoint
          style={styles.bulletpointStyle}
          text={t("LABELLING_SAFETY_1")}
          testID={"labellingScreen_safety_1"}
        />
        <Bulletpoint
          style={styles.bulletpointStyle}
          text={t("LABELLING_SAFETY_2")}
          testID={"labellingScreen_safety_2"}
        />
        <Bulletpoint
          style={styles.bulletpointStyle}
          text={t("LABELLING_SAFETY_3")}
          testID={"labellingScreen_safety_3"}
        />
        <h3 className="TITLE_3" style={styles.headlineBulletPoints}>
          {t("LABELLING_WARNING_TITLE")}
        </h3>
        <Bulletpoint
          style={styles.bulletpointStyle}
          text={t("LABELLING_WARNING_UNDERAGE")}
          testID={"labellingScreen_warning_1"}
        />
        <Bulletpoint
          style={styles.bulletpointStyle}
          text={t("LABELLING_WARNING_PREGNANT")}
          testID={"labellingScreen_warning_2"}
        />
        <Bulletpoint
          style={styles.bulletpointStyle}
          text={t("LABELLING_WARNING_HEALTH")}
          testID={"labellingScreen_warning_3"}
        />
        <h3 className="TITLE_3" style={styles.sectionTitle}>
          {t("LABELLING_SIDE_EFFECTS_TITLE")}
        </h3>
        <p className="REG_TEXT" style={styles.text}>
          {t("LABELLING_SIDE_EFFECTS_TEXT")}
        </p>
        <h3 className="TITLE_3" style={styles.sectionTitle}>
          {t("LABELLING_INTERACTIONS_TITLE")}
        </h3>
        <p className="REG_TEXT" style={styles.text}>
          {t("LABELLING_INTERACTIONS_TEXT")}
        </p>
        <h3 className="TITLE_3" style={styles.listTitle}>
          {t("LABELLING_MANUAL_TITLE")}
        </h3>
        <a href="https://smokeless.world/ifu">
          <ListItemAssetLarge
            style={styles.listItems}
            text={t("LABELLING_MANUAL_URL")}
            icon={getAsset("manual")}
            testID={"labellingScreen_manual"}
          />
        </a>
        <h3 className="TITLE_3" style={styles.listTitle}>
          {t("LABELLING_SUPPORT_TITLE")}
        </h3>
        <ListItemAssetLarge
          text={t("LABELLING_SUPPORT_TEXT")}
          icon={getAsset("support")}
          testID={"labellingScreen_support_text"}
        />
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100%",
    padding: "20px",
    maxWidth: "600px",
    display: "inline-block",
  },

  bulletpointStyle: { paddingLeft: 20, paddingRight: 16, marginRight: 16 },
  headline: { marginTop: 56 },
  listTitle: { marginBottom: 12 },
  version: { marginTop: 8, marginBottom: 8 },
  sectionTitle: { marginTop: 40 },
  text: { marginTop: 20 },
  headlineBulletPoints: { marginTop: 40, marginBottom: 4 },
  listItems: { paddingLeft: 8, addingRight: 8 },
  content: { paddingRight: 20, addingLeft: 20 },
  lastItem: { marginBottom: 100 },
  textStyle: {
    opacity: 0.8,
    flex: 1,
  },
};



// WEBPACK FOOTER //
// ./src/components/screens/LabelingScreen.tsx